import * as React from 'react';

import { FormControl, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

import { MaskedInput } from './MaskedInput';
import { getFieldErrorMessage, useFormContext } from '../FormProvider';

type Props = {
  name: string;
  label: string;
  mask: string;
  disabled?: boolean;
  fullWidth?: boolean;
  margin?: 'none' | 'dense' | 'normal';
};

export const ControlledMaskedTextField: React.FC<Props> = ({
  name,
  label,
  mask,
  fullWidth = true,
  disabled = false,
  margin = 'normal',
}) => {
  const { control, errors } = useFormContext();

  return (
    <FormControl fullWidth={fullWidth} margin={margin}>
      <Controller
        name={name}
        control={control}
        render={({ field: { ref, ...field } }) => (
          <TextField
            {...field}
            inputRef={ref}
            label={label}
            error={!!errors?.[name]}
            disabled={disabled}
            helperText={getFieldErrorMessage(errors?.[name])}
            InputProps={{
              inputComponent: MaskedInput,
              inputProps: {
                mask,
              },
            }}
          />
        )}
      />
    </FormControl>
  );
};
